import gql from 'graphql-tag';
import { USER_FRAGMENT } from 'libs/graphql/fragment/userFragment';

export const UPDATE_USER_MUTATION = gql`
    mutation UpdateUser($userInfo: UserInfoEditInput!) {
        updateUser(userInfo: $userInfo) {
            ...FUser
        }
    }
    ${USER_FRAGMENT}
`;
